import { createApp } from 'vue'
const ACTION_KEY = {
  /** 政策 */
  POLICY: {
    ADD: 'Policy:Add',
    EDIT: 'Policy:Edit',
    DEL: 'Policy:Del',
    DETAIL: 'PolicyDetail',
    ORDER: 'Policy:Order',
    ENABLE: 'Policy:Enable',
    DISABLE: 'Policy:Disable'
  },
  /** 新闻公告 */
  NEWS: {
    ADD: 'News:Add',
    EDIT: 'News:Edit',
    DEL: 'News:Del',
    DETAIL: 'NewsDetail',
    ORDER: 'News:Order',
    ENABLE: 'News:Enable',
    DISABLE: 'News:Disable'
  },
  /** 权限 */
  PERMISSION: {
    ADD: 'Permission:Add',
    EDIT: 'Permission:Edit',
    DEL: 'Permission:Del',
    ORDER: 'Permission:Order',
    ENABLE: 'Permission:Enable',
    DISABLE: 'Permission:Disable'
  },
  /** 部门 */
  DEPARTMENT: {
    ADD: 'Department:Add',
    EDIT: 'Department:Edit',
    DEL: 'Department:Del',
    ORDER: 'Department:Order',
    ENABLE: 'Department:Enable',
    DISABLE: 'Department:Disable'
  },
  /** 菜单 */
  MENU: {
    ADD: 'Menu:Add',
    EDIT: 'Menu:Edit',
    DEL: 'Menu:Del',
    ORDER: 'Menu:Order',
    ENABLE: 'Menu:Enable',
    DISABLE: 'Menu:Disable',
    ASSIGN_PERMISSION: 'Menu:AssignPermission'
  },
  /** 字典 */
  DICTIONARY: {
    ADD: 'Dictionary:Add',
    EDIT: 'Dictionary:Edit',
    DEL: 'Dictionary:Del',
    ORDER: 'Dictionary:Order',
    ENABLE: 'Dictionary:Enable',
    DISABLE: 'Dictionary:Disable'
  },
  /** 角色 */
  ROLE: {
    ADD: 'Role:Add',
    EDIT: 'Role:Edit',
    DEL: 'Role:Del',
    ENABLE: 'Role:Enable',
    DISABLE: 'Role:Disable',
    ORDER: 'Role:Order',
    BIND_MENU: 'Role:BindMenu',
    BIND_DEPARTMENT: 'Role:BindDepartment'
  },
  /** 部门与用户管理 */
  DEPART_USER: {
    ADD: 'DepartUser:Add',
    EDIT: 'DepartUser:Edit',
    DEL: 'DepartUser:Del',
    ENABLE: 'DepartUser:Enable',
    DISABLE: 'DepartUser:Disable',
    ORDER: 'DepartUser:Order',
    IMPORT: 'DepartUser:Import',
    RESET_PWD: 'DepartUser:ResetPwd',
    BIND_ROLE: 'DepartUser:BindRole',
    MERGE: 'DepartUser:Merge'
  },
  /** 公职人员 */
  PUBLIC_SERVANT: {
    ADD: 'PublicServant:Add',
    EDIT: 'PublicServant:Edit',
    DEL: 'PublicServant:Del',
    ENABLE: 'PublicServant:Enable',
    DISABLE: 'PublicServant:Disable',
    ORDER: 'PublicServant:Order',
    IMPORT: 'PublicServant:Import'
  },
  /** 原始档案-项目 */
  ORIGIN_ARCHIVE_XM: {
    ADD: 'OriginArchiveXm:Add',
    EDIT: 'OriginArchiveXm:Edit',
    DEL: 'OriginArchiveXm:Del',
    ENABLE: 'OriginArchiveXm:Enable',
    DISABLE: 'OriginArchiveXm:Disable',
    ORDER: 'OriginArchiveXm:Order',
    EXPORT: 'OriginArchiveXm:Export',
    DETAIL: 'OriginArchiveXm:Detail',
    PRINT: 'OriginArchiveXm:Print'
  },
  /** 原始档案-征拆户 */
  ORIGIN_ARCHIVE_ZCH: {
    ADD: 'OriginArchiveZch:Add',
    EDIT: 'OriginArchiveZch:Edit',
    DEL: 'OriginArchiveZch:Del',
    ENABLE: 'OriginArchiveZch:Enable',
    DISABLE: 'OriginArchiveZch:Disable',
    ORDER: 'OriginArchiveZch:Order',
    EXPORT: 'OriginArchiveZch:Export',
    DETAIL: 'OriginArchiveZch:Detail',
    PRINT: 'OriginArchiveZch:Print'
  },
  /** 小区管理 */
  COMMUNITY: {
    _INDEX: 'Community',
    CREATE: 'CommunityCreate',
    UPDATE: 'CommunityUpdate',
    DETAIL: 'CommunityDetail',
    DEL: 'Community:Del',
    ENABLE: 'Community:Enable',
    DISABLE: 'Community:Disable',
    ORDER: 'Community:Order',
    HOUSE_TYPE: 'CommunityHouseType',
    HOUSE: 'CommunityHouse'
  },
  /** 小区户型 */
  COMMUNITY_HOUSE_TYPE: {
    ADD: 'CommunityHouseType:Add',
    EDIT: 'CommunityHouseType:Edit',
    DEL: 'CommunityHouseType:Del'
  },
  /** 小区房源 */
  HOUSE: {
    ADD: 'House:Add',
    EDIT: 'House:Edit',
    DEL: 'House:Del',
    IMPORT: 'House:Import'
  },
  /** 集体土地项目 */
  JT_PROJ: {
    _INDEX: 'JtProjManage',
    CREATE: 'JtProjCreate',
    UPDATE: 'JtProjUpdate',
    DEL: 'JtProj:Del',
    ENABLE: 'JtProj:Enable',
    DISABLE: 'JtProj:Disable',
    ORDER: 'JtProj:Order',
    DETAIL: 'JtProjDetail',
    EXPORT: 'JtProj:Export',
    HOUSE_BIND: 'JtProj:HouseBind',
    ANA: 'JtProj:Ana'
  },
  /** 集体土地项目-编辑（模块） */
  JT_PROJ_UPDATE: {
    _INDEX: 'JtProjUpdate',
    BASIC_INFO: 'JtProjUpdate:BasicInfo',
    PROGRESS: 'JtProjUpdate:Progress',
    POINT: 'JtProjUpdate:Point',
    COMP_STANDARD: 'JtProjUpdate:CompStandard',
    RESETTLE_STANDARD: 'JtProjUpdate:ResettleStandard',
    CLOSURE: 'JtProjUpdate:Closure',
    SS_IMPORT: 'JtProjUpdate:SSImport'
  },
  /** 集体土地项目-详情（模块） */
  JT_PROJ_DETAIL: {
    BASIC_INFO: 'JtProjDetail:BasicInfo',
    PROGRESS: 'JtProjDetail:Progress',
    POINT: 'JtProjDetail:Point',
    COMP_STANDARD: 'JtProjDetail:CompStandard',
    RESETTLE_STANDARD: 'JtProjDetail:ResettleStandard',
    CLOSURE: 'JtProjDetail:Closure',
    FUND_AUDIT: 'JtProjDetail:FundAudit',
    KICKOFF_MEETING: 'JtProjDetail:KickoffMeeting',
    ORIGIN_ARCHIVE: 'JtProjDetail:OriginArchive',
    GROUP_AGREEMENT: 'JtProjDetail:GroupAgreement',
    FUND_CLEARING: 'JtProjDetail:FundClearing',
    FUND_SUMMARY: 'JtProjDetail:FundSummary',
    PENSION_INSURANCE: 'JtProjDetail:PensionInsurance',
    RESETTLE_AUDIT: 'JtProjDetail:ResettleAudit',
    ZCH_LIST: 'JtProjDetail:ZchList',
    PRE_PHOTO: 'JtProjDetail:PrePhoto'
  },
  /** 集体土地项目-录入 */
  JT_PROJ_DATA: {
    _INDEX: 'JtProjData',
    PROJ_ENTRY: 'JtProjDataEntry'
  },
  /** 集体土地项目-录入（模块） */
  JT_PROJ_DATA_ENTRY: {
    FUND_AUDIT: 'JtProjDataEntry:FundAudit',
    KICKOFF_MEETING: 'JtProjDataEntry:KickoffMeeting',
    ORIGIN_ARCHIVE: 'JtProjDataEntry:OriginArchive',
    GROUP_AGREEMENT: 'JtProjDataEntry:GroupAgreement',
    FUND_CLEARING: 'JtProjDataEntry:FundClearing',
    FUND_SUMMARY: 'JtProjDataEntry:FundSummary',
    PENSION_INSURANCE: 'JtProjDataEntry:PensionInsurance',
    RESETTLE_AUDIT: 'JtProjDataEntry:ResettleAudit',
    PRE_PHOTO: 'JtProjDataEntry:PrePhoto'
  },
  /** 集体土地项目-征拆户 */
  JT_ZCH: {
    CREATE: 'JtZchCreate',
    UPDATE: 'JtZchUpdate',
    DETAIL: 'JtZchDetail',
    DEL: 'JtZch:Del',
    ENABLE: 'JtZch:Enable',
    DISABLE: 'JtZch:Disable',
    ORDER: 'JtZch:Order',
    ANA: 'JtZch:Ana'
  },
  /** 集体土地项目-征拆户-编辑（模块） */
  JT_ZCH_UPDATE: {
    BASIC_INFO: 'JtZchUpdate:BasicInfo',
    GOU_FANG_CONTRACT: 'JtZchUpdate:GouFangContract',
    FAMILY_MEMBERS: 'JtZchUpdate:FamilyMembers',
    SOCIAL_SECURITY: 'JtZchUpdate:SocialSecurity',
    RELATED_PHOTOS: 'JtZchUpdate:RelatedPhotos',
    COMP_AGREEMENT: 'JtZchUpdate:CompAgreement',
    ATTACHMENTS: 'JtZchUpdate:Attachments',
    RESETTLE: 'JtZchUpdate:Resettle',
    COMP: 'JtZchUpdate:Comp',
    ORIGIN_ARCHIVE: 'JtZchUpdate:OriginArchive',
    PRINT: 'JtZchUpdate:Print',
    DOWNLOAD: 'JtZchUpdate:Download'
  },
  /** 集体土地项目-征拆户-详情（模块） */
  JT_ZCH_DETAIL: {
    BASIC_INFO: 'JtZchDetail:BasicInfo',
    FAMILY_MEMBERS: 'JtZchDetail:FamilyMembers',
    SOCIAL_SECURITY: 'JtZchDetail:SocialSecurity',
    RELATED_PHOTOS: 'JtZchDetail:RelatedPhotos',
    COMP_AGREEMENT: 'JtZchDetail:CompAgreement',
    ATTACHMENTS: 'JtZchDetail:Attachments',
    RESETTLE: 'JtZchDetail:Resettle',
    COMP: 'JtZchDetail:Comp',
    PRINT: 'JtZchDetail:Print',
    DOWNLOAD: 'JtZchDetail:Download'
  },
  /** 集体土地-征拆户-审核 */
  JT_ZCH_REVIEW: {
    _INDEX: 'JtZchReview',
    HANDLE: 'JtZchReview:Handle'
  },
  /** 国有土地项目 */
  GY_PROJ: {
    _INDEX: 'GyProjManage',
    CREATE: 'GyProjCreate',
    UPDATE: 'GyProjUpdate',
    DEL: 'GyProj:Del',
    ENABLE: 'GyProj:Enable',
    DISABLE: 'GyProj:Disable',
    ORDER: 'GyProj:Order',
    DETAIL: 'GyProjDetail',
    EXPORT: 'GyProj:Export',
    ANA: 'GyProj:Ana'
  },
  /** 国有土地项目-编辑（模块） */
  GY_PROJ_UPDATE: {
    _INDEX: 'GyProjUpdate',
    BASIC_INFO: 'GyProjUpdate:BasicInfo',
    PROGRESS: 'GyProjUpdate:Progress',
    POINT: 'GyProjUpdate:Point',
    SURVEY_ARCHIVE: 'GyProjUpdate:SurveyArchive',
    KICKOFF_MEETING: 'GyProjUpdate:KickoffMeeting',
    APPRAISAL_COMPANY: 'GyProjUpdate:AppraisalCompany',
    HOME_ASSESSMENT: 'GyProjUpdate:HomeAssessment',
    PRE_ASSESSMENT_NOTICE: 'GyProjUpdate:PreAssessmentNotice',
    FUND_APPROVAL: 'GyProjUpdate:FundApproval',
    HOUSE_DEMOLITION: 'GyProjUpdate:HouseDemolition',
    CERT_CANCEL: 'GyProjUpdate:CertCancel',
    ORIGIN_ARCHIVE: 'GyProjUpdate:OriginArchive',
    CLOSURE: 'GyProjUpdate:Closure'
  },
  /** 国有土地项目-详情（模块） */
  GY_PROJ_DETAIL: {
    BASIC_INFO: 'GyProjDetail:BasicInfo',
    POINT: 'GyProjDetail:Point',
    SURVEY_ARCHIVE: 'GyProjDetail:SurveyArchive',
    KICKOFF_MEETING: 'GyProjDetail:KickoffMeeting',
    APPRAISAL_COMPANY: 'GyProjDetail:AppraisalCompany',
    HOME_ASSESSMENT: 'GyProjDetail:HomeAssessment',
    PRE_ASSESSMENT_NOTICE: 'GyProjDetail:PreAssessmentNotice',
    FUND_APPROVAL: 'GyProjDetail:FundApproval',
    HOUSE_DEMOLITION: 'GyProjDetail:HouseDemolition',
    CERT_CANCEL: 'GyProjDetail:CertCancel',
    ORIGIN_ARCHIVE: 'GyProjDetail:OriginArchive',
    CLOSURE: 'GyProjDetail:Closure'
  },
  /** 国有土地项目-录入 */
  GY_PROJ_DATA: {
    _INDEX: 'GyProjData'
  },
  /** 国有土地项目-征拆户 */
  GY_ZCH: {
    CREATE: 'GyZchCreate',
    UPDATE: 'GyZchUpdate',
    DETAIL: 'GyZchDetail',
    DEL: 'GyZch:Del',
    ENABLE: 'GyZch:Enable',
    DISABLE: 'GyZch:Disable',
    ORDER: 'GyZch:Order',
    ANA: 'GyZch:Ana'
  },
  /** 国有土地项目-征拆户-编辑（模块） */
  GY_ZCH_UPDATE: {
    BASIC_INFO: 'GyZchUpdate:BasicInfo',
    HOUSE_INFO: 'GyZchUpdate:HouseInfo',
    OWNER_INFO: 'GyZchUpdate:OwnerInfo',
    OTHER_INFO: 'GyZchUpdate:OtherInfo',
    ORIGIN_ARCHIVE: 'GyZchUpdate:OriginArchive',
    ATTACHMENTS: 'GyZchUpdate:Attachments'
  },
  /** 国有土地项目-征拆户-审核 */
  GY_ZCH_REVIEW: {
    _INDEX: 'GyZchReview',
    HANDLE: 'GyZchReview:Handle'
  },
  /** 风险数据告警 */
  DATA_ALARM: {
    HANDLE: 'DataAlarm:Handle'
  },
  /** 房票放款 */
  TICKET_LOAN: {
    DEL: 'TicketLoan:Del',
    EXPORT: 'TicketLoan:Export',
    PREPAY_MARK: 'TicketLoan:PrepayMark',
    IMPORT: 'TicketLoanImp',
    ANA: 'TicketLoan:Ana'
  },
  /** 安置监审审核 */
  RESETTLE_AUDIT_REVIEW: {
    HANDLE: 'ResettleAuditReview:Handle'
  },
  /** 资金监审审核 */
  FUND_AUDIT_REVIEW: {
    HANDLE: 'FundAuditReview:Handle'
  },
  /** 养老保险审核 */
  PENSION_INSURANCE_REVIEW: {
    HANDLE: 'PensionInsuranceReview:Handle'
  },
  /** 全局搜索 */
  GLOBAL_SEARCH: {
    _INDEX: 'GlobalSearch'
  },
  /** 房票列表 */
  TICKET_LIST: {
    ANA: 'TicketList:Ana'
  }
}
export default (app: ReturnType<typeof createApp>) => {
  app.config.globalProperties.$AK = ACTION_KEY
}
export const useActionKey = () => {
  return ACTION_KEY
}
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $AK: typeof ACTION_KEY
  }
}
